export default "assets/images/icons/marker-8d761906.svg";